<template>
    <div class="ct-input-element ct-check-input">
        <div class="ct-title ct-v-align">
            <label v-if="!isRequired" :for="inputFieldId">{{ label }}</label>
            <label v-if="isRequired" :for="inputFieldId">{{ label }}*</label>
            <i
                v-show="hasHint"
                class="material-icons"
                data-toggle="tooltip"
                data-placement="bottom"
                :title="$t(getHint)"
                :data-original-title="$t(getHint)"
                >help_outline</i
            >
        </div>
        <div class="ct-content" :class="{ 'has-error': hasError }">
            <div v-show="hasPrefix">
                <p class="form-control-static">
                    {{ prefix }}
                </p>
            </div>
            <div>
                <div>
                    <input :id="inputFieldId" v-model="iModel" class="form-control" type="text" />
                </div>
            </div>
            <div v-show="hasSuffix">
                <p class="form-control-static">
                    {{ suffix }}
                </p>
            </div>
            <div v-show="hasIcon" class="ct-v-align" :class="iconClass">
                <i class="material-icons">{{ checkIcon }}</i>
            </div>
        </div>
        <div :class="{ 'has-error': hasError }">
            <span v-show="hasError" class="help-block">{{ getError }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: ['config', 'inputModel', 'error', 'icon', 'iconClass'],
    data: function() {
        return {};
    },
    computed: {
        iModel: {
            get: function() {
                return this.inputModel;
            },
            set: function(newValue) {
                this.$emit('update:inputModel', newValue);
            }
        },
        inputFieldId: function() {
            if (typeof this.config !== 'undefined' && typeof this.config.id !== 'undefined' && this.config.id !== '') {
                return this.config.id;
            }

            return '';
        },
        label: function() {
            if (
                typeof this.config !== 'undefined' &&
                typeof this.config.translationKey !== 'undefined' &&
                this.config.translationKey !== ''
            ) {
                return this.$i18n.t(this.config.translationKey);
            }

            return '';
        },
        hasPrefix: function() {
            return (
                typeof this.config !== 'undefined' &&
                typeof this.config.prefix !== 'undefined' &&
                this.config.prefix !== ''
            );
        },
        prefix: function() {
            return this.hasPrefix ? this.config.prefix : '';
        },
        hasSuffix: function() {
            return (
                typeof this.config !== 'undefined' &&
                typeof this.config.suffix !== 'undefined' &&
                this.config.suffix !== ''
            );
        },
        suffix: function() {
            return this.hasSuffix ? this.config.suffix : '';
        },
        getHint: function() {
            return this.hasHint ? this.config.hint : '';
        },
        hasHint: function() {
            return (
                typeof this.config !== 'undefined' && typeof this.config.hint !== 'undefined' && this.config.hint !== ''
            );
        },
        isRequired: function() {
            return (
                typeof this.config !== 'undefined' &&
                typeof this.config.required !== 'undefined' &&
                this.config.required
            );
        },
        hasError: function() {
            return this.error !== 'undefined' && this.error !== '';
        },
        getError: function() {
            return this.hasError ? this.error : '';
        },
        hasIcon: function() {
            return typeof this.icon !== 'undefined' && this.icons !== '';
        },
        checkIcon: function() {
            return this.hasIcon ? this.icon : '';
        }
    }
};
</script>
<style>
.ct-content {
    display: flex;
    flex-direction: row;
}
</style>
